import React, { useCallback } from 'react';
import { MetricActions, MetricCategories } from '../../application/analitics/umami/TrackEventParams';
import { useUmamiTracker } from '../../application/analitics/umami/useUmamiTracker';
import { ReactComponent as UserPlus } from '../../assets/img/patient/user_plus.svg';
import Style from './addPatientButton.module.scss';
import TablePageLayout from '../tablePageLayout/TablePageLayout';
import Portal from 'uikit/portal/Portal';
import { useFormEditing } from 'src/features/forms/editing/useFormEditing';
import { useQueryClient } from '@tanstack/react-query';
import { QueryFactory } from 'src/services/api';
import { useStudy } from 'src/helpers/hooks/useStudy';
import { useHasAccessToForm } from 'src/helpers/auth/auth-helper';

export const AddPatientButton = () => {
  const study = useStudy();
  const form = useFormEditing({ testId: 'Initial-form' });
  const { trackEvent } = useUmamiTracker();
  const queryClient = useQueryClient();
  const { hasAccessToForm } = useHasAccessToForm();

  const onShow = useCallback(async () => {
    if (!study?.patientCreationFormBinding?.id) throw new Error('No patient creation form');
    await form.startFormFilling({ formId: study?.patientCreationFormBinding?.id, patientId: undefined });
    await queryClient.invalidateQueries(QueryFactory.ProfileQuery.getDoctorProfileInfoQueryKey());
    trackEvent({ action: MetricActions.ButtonPressed, category: MetricCategories.Patient, name: 'AddPatientButton' });
  }, [form, queryClient, study?.patientCreationFormBinding?.id, trackEvent]);

  if (study?.closingApprovedAt || !hasAccessToForm(study?.patientCreationFormBinding?.id)) return <></>;

  return (
    <>
      <TablePageLayout.TableContainer.FloatingButton
        onClick={onShow}
        Icon={UserPlus}
        className={Style.button}
        testId={'create-patient-button'}
      />

      <Portal>
        {/* Portal is used because */}
        {/* some element from Fluent UI adds extra <span/> */}
        {/* and it causes a gap between the floating button and this <span/> */}
        {form.element}
      </Portal>
    </>
  );
};
